export const contactTitles = [
    { attributeName: "Mr", attributeValue: 126560000 },
    { attributeName: "Miss", attributeValue: 126560001 },
    { attributeName: "Mrs", attributeValue: 126560002 },
    { attributeName: "Ms", attributeValue: 126560003 },
    { attributeName: "Cllr", attributeValue: 126560004 },
    { attributeName: "Rev", attributeValue: 126560005 },
    { attributeName: "Dr", attributeValue: 126560006 },
    { attributeName: "Lord", attributeValue: 126560007 },
    { attributeName: "Lady", attributeValue: 126560008 },
    { attributeName: "SIRGENERAL", attributeValue: 126560009 },
    { attributeName: "Captain", attributeValue: 126560010 },
    { attributeName: "Sergent", attributeValue: 126560011 },
];
export const educationTypes = [
    { attributeName: "Primary", attributeValue: 126560000 },
    { attributeName: "Secondary", attributeValue: 126560001 },
    { attributeName: "Sixth Form School", attributeValue: 126560002 },
    { attributeName: "Sixth Form College", attributeValue: 126560003 },
    { attributeName: "Further Education College", attributeValue: 126560004 },
    { attributeName: "Post 16 Training", attributeValue: 126560005 }
];
export const groundsForApplicationTypes = [
    { attributeName: "Distance", attributeValue: 126560000 },
    { attributeName: "Low Income", attributeValue: 126560001 },
    { attributeName: "Medical Or Special Education Needs", attributeValue: 126560002 }
];
export const mobilityEquipmentTypes = [
    { attributeName: "Not Applicable", attributeValue: 126560000 },
    { attributeName: "Manual Wheelchair", attributeValue: 126560001 },
    { attributeName: "Electric Wheelchair", attributeValue: 126560002 },
    { attributeName: "Buggy", attributeValue: 126560003 },
    { attributeName: "Walking Frame", attributeValue: 126560004 }
];
export const seatTypes = [
    { attributeName: "Not Applicable", attributeValue: 126560000 },
    { attributeName: "Junior Car Seat", attributeValue: 126560001 },
    { attributeName: "Booster Seat", attributeValue: 126560002 },
    { attributeName: "Booster Cushion", attributeValue: 126560003 },
    { attributeName: "Special Child Seat", attributeValue: 126560004 }
];

export const CourseHoursTypes = [
    { attributeName: "Under 10 Hours", attributeValue: 126560000 },
    { attributeName: "10 TO 15 Hours", attributeValue: 126560001 },
    { attributeName: "16 TO 20 Hours", attributeValue: 126560002 },
    { attributeName: "Over 20 Hours", attributeValue: 126560003 }
];